import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { services } from '@/data/services';
import { company } from '@/data/company';
import { getIcon } from '@/components/common/iconMap';
import { Wrench } from 'lucide-react';

const IndustriesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const sectors = [
    ...services.map((service) => ({ name: service.title, icon: service.icon })),
    { name: company.electromechanical.title, icon: 'Wrench' },
  ];

  return (
    <section ref={ref} className="py-24 relative bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-semibold text-[#398024] tracking-wider uppercase mb-3">Sectors we serve</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Built around real industrial demand
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our work follows the sectors published in MAYAN’s services and electromechanical capabilities.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {sectors.map((sector, index) => {
            const Icon = sector.icon === 'Wrench' ? Wrench : getIcon(sector.icon);
            return (
              <motion.div
                key={sector.name}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                className="group relative bg-white border border-gray-200 rounded-xl p-6 hover:border-[#398024] hover:shadow-lg transition-all duration-300"
              >
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#398024] rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h4 className="text-gray-900 font-semibold text-sm leading-snug">{sector.name}</h4>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
